import styled from "@emotion/styled";
import React, { useEffect, useRef, useState } from "react";

import { TICKET_TYPE, TICKET_TYPE_STRING } from "@src/components/deungi/common/enum";

import CommonPackageListBox from "./CommonPackageListBox";
import ExpertPaymentInfoBox from "@src/components/expert/ticket/ExpertPaymentInfoBox";
import CommonTicketItem from "@src/components/expert/ticket/CommonTicketItem";

import auction_agent_with_consulting_ticket_ico from "@src/assets/expert/ticket/consultIcon.png";
import { PackageListBoxStyle } from "./ExpertCompanionPackageListBox";

const ExpertConsultingPackageListBox = () => {
    const ticketImage = auction_agent_with_consulting_ticket_ico;
    const ticketTypeString = TICKET_TYPE_STRING.ITEM_CONSULTING_TICKET;
    const ticketTitle = "매물컨설팅 전문가 매칭 이용권";
    return (
        <Container>
            <TicketContainer>
                <CommonTicketItem
                    ticketTypeNumber={TICKET_TYPE.ITEM_CONSULTING_TICKET}
                    ticketTitle={ticketTitle}
                    ticketImage={ticketImage}
                />
            </TicketContainer>
            <PackageListBoxStyle>
                <CommonPackageListBox ticketTypeString={ticketTypeString} ticketTitle={ticketTitle} ticketImage={ticketImage} />
            </PackageListBoxStyle>
            <ExpertPaymentInfoBox ticketType={ticketTypeString} title={ticketTitle} />
        </Container>
    );
};

const Container = styled.div`
    height: 100%;
    overflow: scroll;
    background-color: white;
    .backDiv {
        width: 0;
        height: 75px;
    }
`;

const TicketContainer = styled.div`
    position: fixed;
    display: flex;
    align-items: center;
    background: #fff;
    box-sizing: border-box;
    width: 100%;
    top: 55px;
    gap: 10px;
    padding: 0 14px 14px;
    z-index: 2;

    & > div {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 10px;
    }

    .ticketItem {
        display: flex;

        border-radius: 8px;
        padding: 12px 8px;
        transition: all 0.2s ease;
        background: #f6faff;

        & > h3 {
            color: #0c002c;
            font-size: 13px;
            font-weight: 500;
            line-height: 1.4;
            min-width: 80px;
            width: max-content;
            text-align: center;
            margin: 4px auto 0;

            & > label {
                display: block;
                font-size: 14px;
                font-weight: 700;
                color: #0047ff;
                text-align: center;
            }
        }
        & > img {
            width: 38px;
            height: 38px;
            background: #fff;
            border-radius: 4px;
            padding: 6px;
            margin: auto;
        }
    }
`;

export default ExpertConsultingPackageListBox;
